import { render, staticRenderFns } from "./NavegationMenu.vue?vue&type=template&id=4a2359b9&scoped=true"
import script from "./NavegationMenu.vue?vue&type=script&lang=js"
export * from "./NavegationMenu.vue?vue&type=script&lang=js"
import style0 from "./NavegationMenu.vue?vue&type=style&index=0&id=4a2359b9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2359b9",
  null
  
)

export default component.exports